<template>
  <div>
    <div>
      <div v-if="loading" class="p-6">
        <Loading />
      </div>
      <div class="p-6 text-center text-gray-500 border rounded bg-gray-50" v-else-if="addons.meta.total < 1">
        <div>You have no addons.</div>
      </div>
      <div v-else>
        <div class="overflow-x-visible overflow-y-auto border rounded h-96">
          <label class="flex items-center px-4 py-2 border-0 border-b cursor-pointer hover:bg-gray-50" v-for="addon in addons.data" :key="addon.id">
            <input 
              type="checkbox"
              :checked="isInArray(addon.id)" 
              :name="addon.id.toString()" 
              @change="toggleAddon(addon)"
              class="mr-4 text-xl form-checkbox">
            <div class="flex items-center space-x-4">
              <div>
                <div class="flex items-center font-semibold">
                  {{ addon.name }}
                </div>
                <div class="text-gray-500">
                  <currency :value="addon.price" :currency-code="account.currency" :subunits-value="true" />
                </div>
              </div>
            </div>
            <div class="ml-auto text-right">
              <div v-if="addon.status === 'active'">
                <badge class="text-green-800 bg-green-100">Active</badge>
              </div>
              <div v-else-if="addon.status === 'draft'">
                <badge class="text-cyan-800 bg-cyan-100">Draft</badge>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AddonToggle',

  props: {
    parent: {
      type: Object,
      required: true
    }
  },

  async created () {
    await this.getAddons()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      submitting: false,
      loading: true,
      addons: {},
      filter: {
        search: ''
      }
    }
  },

  methods: {
    async getAddons () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/addons`, {
          params: {
            page: this.$route.query.page || 1,
            sort: this.$route.query.sort || 'created_at',
            dir: this.$route.query.dir || 'desc',
            ...this.filter && { filter: this.filter }
          }
        })
        this.addons = data.addons
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },

    toggleAddon (addon) {
      this.$emit('toggle', addon)
    },

    isInArray (id) {
      return this.parent.addons.some(addon => addon.id === id)
    }
  }
}
</script>